import { readPersistedSidebarCollapsed } from '@viapeople/components'
import type React from 'react'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'

interface LayoutProps {
	children?: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = () => {
	const [sidebarCollapsed, setSidebarCollapsed] = useState(() => readPersistedSidebarCollapsed(true))

	return (
		<div className='flex h-screen'>
			<Sidebar onCollapsedChange={setSidebarCollapsed} />
			<div className={`flex-1 overflow-auto transition-[padding] duration-300 ${sidebarCollapsed ? 'pl-15' : 'pl-78'}`}>
				<Outlet />
			</div>
		</div>
	)
}
